'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux';
import { useGetAdminUserPermissionsMutation } from '../redux/services/adminUsersApi';
import { setPermissionsRefetched } from '../redux/slices/authSlice';
export default function PageDetection() {
  const pathName = usePathname();
  const dispatch = useAppDispatch();
  const {
    user: loggedUser,
    permissionsRefetched,
    isMFAVerified
  }: IAuthState = useAppSelector(state => state.auth);
  const [getAdminUserPermission] = useGetAdminUserPermissionsMutation();
  useEffect(() => {
    const storedPath = sessionStorage.getItem('lastPath');
    const shouldRefetchPermissions = !permissionsRefetched && storedPath === pathName || storedPath !== pathName;
    const isMFAConditionMet = !loggedUser?.MFAMandatory || loggedUser?.MFAMandatory && isMFAVerified;
    if (shouldRefetchPermissions && loggedUser && isMFAConditionMet) {
      getAdminUserPermission({
        AdminUserID: loggedUser.AdminUserID
      }).then(() => {
        dispatch(setPermissionsRefetched(true));
      });
    }
  }, [pathName, loggedUser, getAdminUserPermission, dispatch, permissionsRefetched, isMFAVerified]);
  useEffect(() => {
    sessionStorage.setItem('lastPath', pathName);
  }, [pathName]);
  return null;
}